<ham-modal
    [title]="vendor.displayNameKey | i18next"
    [saveText]="(isAdmin ? 'aumico_company_integration_redirect_goto_org_settings' : 'aumico_button_ok') | i18next"
    [showCancelButton]="isAdmin"
    [cancelText]="'aumico_button_close' | i18next"
    [size]="'sm'"
    (save)="onPrimary()"
    (cancel)="onClose()"
>
    <div class="go-to-admin-modal">
        <!-- Connected: show what this company is linked to -->
        <ng-container *ngIf="isConnected">
            <p class="go-to-admin-modal__line">
                <span class="go-to-admin-modal__badge go-to-admin-modal__badge--connected">
                    {{ 'aumico_integration_card_status_connected' | i18next }}
                </span>
            </p>

            <dl class="go-to-admin-modal__details">
                <ng-container *ngIf="connection?.displayName as tenantName">
                    <dt>{{ 'aumico_company_integration_redirect_tenant_label' | i18next }}</dt>
                    <dd>{{ tenantName }}</dd>
                </ng-container>
                <ng-container *ngIf="connection?.d365bc?.vendorEnvironment as env">
                    <dt>{{ 'aumico_company_integration_redirect_environment_label' | i18next }}</dt>
                    <dd>{{ env }}</dd>
                </ng-container>
                <ng-container *ngIf="mapping?.externalCompanyName as extName">
                    <dt>{{ 'aumico_company_integration_redirect_external_company_label' | i18next }}</dt>
                    <dd>{{ extName }}</dd>
                </ng-container>
            </dl>

            <!-- Broken: mapping exists but the org connection is gone / unhealthy -->
            <p *ngIf="isBroken" class="go-to-admin-modal__warning">
                {{ 'aumico_company_integration_redirect_broken' | i18next }}
            </p>
        </ng-container>

        <!-- Always: this integration is managed in the Org Settings. -->
        <p class="go-to-admin-modal__hint">
            {{ 'aumico_company_integration_redirect_managed_in_org' | i18next }}
        </p>

        <!-- Non-admins cannot reach the Org Settings: ask an admin to set it up. -->
        <p *ngIf="!isAdmin" class="go-to-admin-modal__hint">
            {{ 'aumico_integration_managed_in_org_ask_admin' | i18next }}
        </p>
    </div>
</ham-modal>
